import styled from "styled-components";

export const NavigationWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: end;
`;